// import React, { useState } from 'react';
import { CartList } from './components/CartList';
import { Checkout } from './components/CartCheckout';
import { useSearch } from '../../store/context/SearchContext';


export const CartPage = () => {
  const { productsList } = useSearch();
  // const [cart_Item, setCart_Item] = useState([]);

  // let stop = false
let  totalItems ;
let totalPrice;

  // if(productsList && stop === false) {
  //   stop = true
  //   setCart_Item(productsList)
  // }
  console.log(" productsList from cart page", productsList)
  
  // console.log(" productsList from cart page", cart_Item)

  // const totalItems = productsList.reduce((total, product) => total + 1, 0);
  // const totalPrice = productsList.reduce((total, product) => total + (product.price ), 0);
  if(productsList) {
    
     totalItems = productsList.reduce((total, product) => total + (product.quantity || 1), 0);
     totalPrice = productsList.reduce((total, product) => total + (product.price * (product.quantity || 1)), 0);
  }

  console.log("totalItems from cart page", totalItems)
    console.log("totalPrice is here", totalPrice , productsList)
  return (
    <div className="container w-1/2 text-gray-100 mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Shopping Cart</h1>
      {!productsList ? (
        <p>Your cart is empty.{window.location.reload()}</p>
      ) : (
        <>
          <CartList />
          <div className="mt-8">
            <p className="text-xl font-semibold">Total Items: {totalItems}</p>
            <p className="text-2xl font-bold">Total Price ${totalPrice.toFixed(2)}</p>
            the checkout 
          <Checkout cartItems={productsList} total={totalPrice} />
          </div>
          <div>
          
          </div>
        </>
      )}
    </div>
  );
};
